import { Maybe } from '@acme/core'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type State = {
    progresso: Maybe<number>
    state: 'baixando' | 'gerando' | 'idle'
    ultimoProcesso: Maybe<number>
}

type Dispatch =
    | {
          action: 'PROGRESSO'
          data: Maybe<number>
      }
    | {
          action: 'GERANDO_PDF'
          data: boolean
      }
    | {
          action: 'ULTIMO_PROCESSO'
          data: Maybe<number>
      }
    | {
          action: 'BAIXANDO_PDF'
          data: boolean
      }

type Store = {
    state: State
    dispatch: (action: Dispatch, ...actions: Dispatch[]) => void
}

export const useCalculoStore = create<Store>()(
    persist(
        set => ({
            state: {
                progresso: null,
                ultimoProcesso: null,
                state: 'idle' as const,
            },
            dispatch: (...actions) => {
                for (const { action, data } of actions) {
                    switch (action) {
                        case 'PROGRESSO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    progresso: data,
                                },
                            }))
                            break
                        case 'GERANDO_PDF':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    state: data ? 'gerando' : 'idle',
                                },
                            }))
                            break
                        case 'ULTIMO_PROCESSO':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    ultimoProcesso: data,
                                },
                            }))
                            break
                        case 'BAIXANDO_PDF':
                            set(store => ({
                                state: {
                                    ...store.state,
                                    state: data ? 'baixando' : 'idle',
                                },
                            }))
                            break
                    }
                }
            },
        }),
        {
            name: 'calculo-ponto-store',
            partialize: state => ({
                ultimoProcesso: state.state.ultimoProcesso,
            }),
            version: 1,
        },
    ),
)
